import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";

const WeeklyOffTheJobHoursGraph = ({ chartData }) => {
  // console.log("chartData", chartData);

  const weekly = chartData?.data?.weeklyData.map((item) => ({
    ...item,
    Required: parseFloat(item.Required).toFixed(2),
    Submitted: parseFloat(item.Submitted).toFixed(2),
  }));

  return (
    <ResponsiveContainer width="100%" height={400}>
      <BarChart data={weekly} margin={{ top: 20, right: 30, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="week" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Bar dataKey="Required" fill="#8884d8" />
        <Bar dataKey="Submitted" fill="#82ca9d" />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default WeeklyOffTheJobHoursGraph;
